import { Badge } from "@/components/ui/badge";
import { Sparkle } from "lucide-react";
export default function BirthingJoyPhilosophy() {
  return <section data-section-id="223658" id="the-birthing-joy-philosophy" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: "linear-gradient(to bottom, var(--color-chart-2) 1px, transparent 1px)",
      backgroundSize: "100% 4px"
    }} aria-hidden="true" />

      
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-1/2 bg-chart-2/20 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center max-w-4xl border-[rgb(66,48,36)] border-1 !border-none">
        <Badge variant="destructive" className="inline-flex items-center justify-center rounded-md border font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 mb-10 text-sm tracking-[0.2em] uppercase px-4 py-1.5 font-default border-none dark:aria-invalid:ring-destructive/40 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 bg-primary text-secondary">
          Our Philosophy
        </Badge>

        
        <div className="border-l-2 border-r-2 border-chart-2/40 px-6 py-6 flex flex-col gap-8 border-[oklab(0.822569-0.017670.0220013/0.4)] ![border-width:0px_1px_1px_1px] !border-none md:px-16">
          <h2 className="uppercase tracking-wide drop-shadow-sm !font-normal text-primary !font-serif !not-italic !text-[76px]">
            The Birthing Joy Philosophy
          </h2>

          <p className="text-[20px] font-light leading-relaxed max-w-2xl mx-auto text-primary-foreground !font-default">
            "You deserve to feel held." We believe that birth is not just a clinical event, but a sacred transition. 
            Our holistic approach integrates emotional support and professional expertise to ensure you feel 
            empowered, safe, and truly seen throughout your journey into motherhood.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 mt-16 flex items-center justify-center opacity-60">
        <div className="h-[1px] flex-grow !bg-[rgba(217,197,163,1)]" />
        <Sparkle className="text-[#D9C5A3] mx-4 size-5 shrink-0" />
        <div className="h-[1px] flex-grow bg-[#D9C5A3]" />
      </div>
    </section>;
}